import { makeActionCreator } from '../../../utilities'
import { CcHpiConstants } from './ccHpi.constants'

export const setSegment = makeActionCreator(CcHpiConstants.SET_SEGMENT, 'segment')
export const setChiefComplaint = makeActionCreator(CcHpiConstants.SET_CHIEF_COMPLAINT, 'complaint')
export const setAlsAssessmentRationale = makeActionCreator(
  CcHpiConstants.SET_ALS_ASSESSMENT_RATIONALE,
  'alsAssessmentRationale'
)
export const setAlsAssessment = makeActionCreator(CcHpiConstants.SET_ALS_ASSESSMENT, 'alsAssessment')
export const setPatientActivity = makeActionCreator(CcHpiConstants.SET_PATIENT_ACTIVITY, 'patientActivity')
export const setReasonForEncounter = makeActionCreator(CcHpiConstants.SET_REASON_FOR_ENCOUNTER, 'possibleInjury')
export const setDrugsAndAlcohol = makeActionCreator(CcHpiConstants.SET_DRUGS_AND_ALCOHOL, 'drugalc')
export const setDrugsAndAlcoholIndicators = makeActionCreator(
  CcHpiConstants.SET_DRUGS_AND_ALCOHOL_INDICATORS,
  'drugalcIndicators'
)
export const setDrugsAndAlcoholIndicatorsPNNV = makeActionCreator(
  CcHpiConstants.SET_DRUGS_AND_ALCOHOL_INDICATORS_PNNV,
  'drugalcIndicatorsPNNV'
)
export const saveCcHpi = makeActionCreator(CcHpiConstants.SAVE_CC_HPI)
export const setSituationState = makeActionCreator(CcHpiConstants.SET_SITUATION_STATE, 'situation')
export const resetSituationState = makeActionCreator(CcHpiConstants.RESET_SITUATION_STATE)
export const setHistoryState = makeActionCreator(CcHpiConstants.SET_HISTORY_STATE, 'history')
export const resetHistoryState = makeActionCreator(CcHpiConstants.RESET_HISTORY_STATE)

export const setArrestPresent = makeActionCreator(CcHpiConstants.SET_ARREST_PRESENT, 'arrestPresent')
export const setArrestPresentPNNV = makeActionCreator(CcHpiConstants.SET_ARREST_PRESENT_PNNV, 'arrestPresentPNNV')
export const setDTWitnessed = makeActionCreator(CcHpiConstants.SET_DTWITNESSED, 'dtWitnessed')
export const setDTWitnessedPNNV = makeActionCreator(CcHpiConstants.SET_DTWITNESSED_PNNV, 'dtWitnessedPNNV')
export const setUnkWitnessed = makeActionCreator(CcHpiConstants.SET_UNK_WITNESSED, 'unkWitnessed')
export const setWhoWitnessed = makeActionCreator(CcHpiConstants.SET_WHO_WITNESSED, 'whoWitnessed')
export const setEtiology = makeActionCreator(CcHpiConstants.SET_ETIOLOGY, 'etiology')
export const setEtiologyPNNV = makeActionCreator(CcHpiConstants.SET_ETIOLOGY_PNNV, 'etiologyPNNV')
export const setTherapeuticHypothermia = makeActionCreator(
  CcHpiConstants.SET_THERAPEUTIC_HYPOTHERMIA,
  'therapeuticHypothermia'
)
export const setInitialRhythm = makeActionCreator(CcHpiConstants.SET_INITIAL_RHYTHM, 'initialRhythm')
export const setInitialRhythmPNNV = makeActionCreator(CcHpiConstants.SET_INITIAL_RHYTHM_PNNV, 'initialRhythmPNNV')
export const setCprPriorEmsArrival = makeActionCreator(CcHpiConstants.SET_CPR_PRIOR_EMS_ARRIVAL, 'cprPriorEmsArrival')
export const setCprPriorEmsArrivalPNNV = makeActionCreator(
  CcHpiConstants.SET_CPR_PRIOR_EMS_ARRIVAL_PNNV,
  'cprPriorEmsArrivalPNNV'
)
export const setFirstCpr = makeActionCreator(CcHpiConstants.SET_FIRST_CPR, 'firstCpr')
export const setFirstCprPNNV = makeActionCreator(CcHpiConstants.SET_FIRST_CPR_PNNV, 'firstCprPNNV')
export const setDTCpr = makeActionCreator(CcHpiConstants.SET_DTCPR, 'dtCpr')
export const setUnkCpr = makeActionCreator(CcHpiConstants.SET_UNK_CPR, 'unkCpr')
export const setCprBy = makeActionCreator(CcHpiConstants.SET_CPRBY, 'cprBy')
export const setCprType = makeActionCreator(CcHpiConstants.SET_CPRTYPE, 'cprType')
export const setResuscitation = makeActionCreator(CcHpiConstants.SET_RESUSCITATION, 'resuscitation')
export const setAedUse = makeActionCreator(CcHpiConstants.SET_AED_USE, 'aedUse')
export const setFirstAedBy = makeActionCreator(CcHpiConstants.SET_FIRST_AED_BY, 'firstAedBy')
export const setFirstAedByPNNV = makeActionCreator(CcHpiConstants.SET_FIRST_AED_BY_PNNV, 'firstAedByPNNV')
export const setAedBy = makeActionCreator(CcHpiConstants.SET_AED_BY, 'aedBy')
export const setDTDefib = makeActionCreator(CcHpiConstants.SET_DTDEFIB, 'dtDefib')
export const setUnkDefib = makeActionCreator(CcHpiConstants.SET_UNK_DEFIB, 'unkDefib')
export const setDefibType = makeActionCreator(CcHpiConstants.SET_DEFIB_TYPE, 'defibType')
export const setDefibBy = makeActionCreator(CcHpiConstants.SET_DEFIB_BY, 'defibBy')
export const setDefibByPNNV = makeActionCreator(CcHpiConstants.SET_DEFIB_BY_PNNV, 'defibByPNNV')
export const setDTAls = makeActionCreator(CcHpiConstants.SET_DTALS, 'dtAls')
export const setUnkAls = makeActionCreator(CcHpiConstants.SET_UNK_ALS, 'unkAls')
export const setDTDisc = makeActionCreator(CcHpiConstants.SET_DTDISC, 'dtDisc')
export const setUnkDisc = makeActionCreator(CcHpiConstants.SET_UNK_DISC, 'unkDisc')
export const setDiscReason = makeActionCreator(CcHpiConstants.SET_DISC_REASON, 'discReason')
export const setDiscReasonPNNV = makeActionCreator(CcHpiConstants.SET_DISC_REASON_PNNV, 'discReasonPNNV')
export const setDTCirculation = makeActionCreator(CcHpiConstants.SET_DTCIRCULATION, 'dtCirculation')
export const setUnkCirculation = makeActionCreator(CcHpiConstants.SET_UNK_CIRCUALATION, 'unkCirculation')
export const setReturnCirculation = makeActionCreator(CcHpiConstants.SET_RETURN_CIRCULATION, 'returnCirculation')
export const setDTVent = makeActionCreator(CcHpiConstants.SET_DTVENT, 'dtVent')
export const setUnkVent = makeActionCreator(CcHpiConstants.SET_UNK_VENT, 'unkVent')
export const setDestRhythm = makeActionCreator(CcHpiConstants.SET_DEST_RHYTHM, 'destRhythm')
export const setDestRhythmPNNV = makeActionCreator(CcHpiConstants.SET_DEST_RHYTHM_PNNV, 'destRhythmPNNV')
export const setArrestResult = makeActionCreator(CcHpiConstants.SET_ARREST_RESULT, 'arrestResult')
export const setCardiacArrestState = makeActionCreator(CcHpiConstants.SET_CARDIAC_ARREST_STATE, 'ccHpicardiacArrest')
export const saveCardiacArrest = makeActionCreator(CcHpiConstants.SAVE_CARDIAC_ARREST)
export const setCardiacArrestDefaults = makeActionCreator(CcHpiConstants.SET_CARDIAC_ARREST_DEFAULTS)
export const resetCardiacArrestState = makeActionCreator(CcHpiConstants.RESET_CARDIAC_ARREST_STATE)
export const setIntentional = makeActionCreator(CcHpiConstants.SET_INTENTIONAL, 'intentional')
export const setTraumatriageCriteriaHighRisk = makeActionCreator(
  CcHpiConstants.SET_TRAUMA_TRIAGE_CRITERIA_HIGH_RISK,
  'traumaTriageCriteriaHighRisk'
)
export const setTraumaTriageCriteriaHighRiskPNNV = makeActionCreator(
  CcHpiConstants.SET_TRAUMA_TRIAGE_CRITERIA_HIGH_RISK_PNNV,
  'traumaTriageCriteriaHighRiskPNNV'
)
export const setTraumaTriageCriteriaModerateRisk = makeActionCreator(
  CcHpiConstants.SET_TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK,
  'traumaTriageCriteriaModerateRisk'
)
export const setTraumaCriteriaModerateRiskPNNV = makeActionCreator(
  CcHpiConstants.SET_TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK_PNNV,
  'traumaTriageCriteriaModerateRiskPNNV'
)
export const setInjurycause = makeActionCreator(CcHpiConstants.SET_INJURY_CAUSE, 'injurycause')
export const setMechanism = makeActionCreator(CcHpiConstants.SET_MECHANISM, 'mechanism')
export const setMechanismPNNV = makeActionCreator(CcHpiConstants.SET_MECHANISM_PNNV, 'mechanismPNNV')
export const setSafetyEquipment = makeActionCreator(CcHpiConstants.SET_SAFETY_EQUIPMENT, 'safetyEquipment')
export const setSafetyEquipmentPNNV = makeActionCreator(CcHpiConstants.SET_SAFETY_EQUIPMENT_PNNV, 'safetyEquipmentPNNV')
export const setFallHeight = makeActionCreator(CcHpiConstants.SET_FALL_HEIGHT, 'fallHeight')
export const setFallsurface = makeActionCreator(CcHpiConstants.SET_FALL_SURFACE, 'fallsurface')
export const setLandedon = makeActionCreator(CcHpiConstants.SET_LANDED_ON, 'landedon')
export const setWorkrelated = makeActionCreator(CcHpiConstants.SET_WORK_RELATED, 'workrelated')
export const setWorkRelatedPNNV = makeActionCreator(CcHpiConstants.SET_WORK_RELATED_PNNV, 'workrelatedPNNV')
export const setCcDuration = makeActionCreator(CcHpiConstants.SET_CCDURATION, 'ccDuration')
export const setCcDurationUnit = makeActionCreator(CcHpiConstants.SET_CCDURATION_UNIT, 'ccDurationUnit')
export const setScDuration = makeActionCreator(CcHpiConstants.SET_SCDURATION, 'scDuration')
export const setScDurationUnit = makeActionCreator(CcHpiConstants.SET_SCDURATION_UNIT, 'scDurationUnit')
export const setOcDuration = makeActionCreator(CcHpiConstants.SET_OCDURATION, 'ocDuration')
export const setOcDurationUnit = makeActionCreator(CcHpiConstants.SET_OCDURATION_UNIT, 'ocDurationUnit')
export const setSecondaryComplaint = makeActionCreator(CcHpiConstants.SET_SECONDARY_COMPLAINT, 'secondaryComplaint')
export const setOtherComplaints = makeActionCreator(CcHpiConstants.SET_OTHER_COMPLAINTS, 'otherComplaints')
export const setOtherComplaint = makeActionCreator(CcHpiConstants.SET_OTHER_COMPLAINT, 'otherComplaint')
export const setCCHPIDefaults = makeActionCreator(CcHpiConstants.SET_CCHPI_DEFAULTS, '__areDefaultsSet')
export const setCcHpiInjuryDetails = makeActionCreator(CcHpiConstants.SET_CCHPI_INJURY_DETAILS, 'ccHpiInjuryDetails')
export const resetCcHpiInjuryDetails = makeActionCreator(CcHpiConstants.RESET_CCHPI_INJURY_DETAILS)
